function scrollWindow() {

    window.scrollBy({
        top: 3,
        left: 0,
        behavior: 'smooth'
    });

    if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight) {
        scroller.stop();
        scroller.scrolling = false;
    }
}



var scroller = {
    scrollTimer: null,
    timeOutTimer: null,
    speed: 250,
    startPause: 50000,
    scrolling : false,

    start: function () {
        scroller.scrollTimer = setInterval(scrollWindow, scroller.speed);
    },

    stop: function () {
        //scroller.speed = 0;
        clearTimeout(scroller.timeOutTimer);
        clearInterval(scroller.scrollTimer);
    }
};

export function startScroll(status) {
    if (status== 0) {        
        scroller.stop();
    }
    else {        
        scroller.timeOutTimer = setTimeout(scroller.start, scroller.startPause);
        scroller.scrolling = true;
    }
}

export function scrollToTop() {
    window.scrollTo(0, 0);
}